import { gql } from 'apollo-angular';
import { ApiKey } from '../../entities/apiKey/apiKey';
import { Page } from '../../entities/page/page';


export const API_KEYS_QUERY = gql`
query apiKeysQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String)
{
  apiKeys: getApiKeysPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          hash
          comment
          lastUsedDateTime
      }
  }
}
`;

export interface ApiKeysQueryResponse {
  apiKeys: Page<ApiKey>;
  loading: boolean;
}
